import React from "react";
import Chart from "react-apexcharts";

const FunnelChart = ({ data = [] }) => {
  if (!data.length) {
    return <div className="text-muted text-center">No data available</div>;
  }

  const categories = data.map((d) =>
    d.label || d.step?.replace(/_/g, " ") || ""
  );

  const series = [
    {
      name: "Users",
      data: data.map((d) => d.users),
    },
  ];

  // One journey, deepening stages: a funnel is ONE series moving through
  // ordered depths, so it wears ONE hue that darkens down the funnel -
  // never a rainbow of identities. The stage names on the left are the
  // legend; the color legend that duplicated them is gone (2026-09-01).
  const PURPLE_RAMP = [
    "#a795f4", "#9a83ef", "#8d72e7", "#7f62dc",
    "#7152cd", "#6242bc", "#5233a8", "#422591",
  ];
  const barColors = data.map(
    (_, idx) => PURPLE_RAMP[Math.min(idx, PURPLE_RAMP.length - 1)]
  );

  const options = {
    chart: {
      type: "bar",
      toolbar: { show: true },
    },
    colors: barColors,
    legend: { show: false },
    plotOptions: {
      bar: {
        horizontal: true,
        distributed: true,
        barHeight: "70%",
        borderRadius: 4,
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (val, opts) => {
        const conversion = data[opts.dataPointIndex].conversion;
        return `${val} users (${conversion}%)`;
      },
      style: {
        fontSize: "12px",
        colors: ["#ffffff"],
      },
      dropShadow: { enabled: true, top: 0, left: 0, blur: 2, opacity: 0.5 },
    },
    xaxis: {
      categories,
    },
    tooltip: {
      y: {
        formatter: (val, opts) => {
          const row = data[opts.dataPointIndex] || {};
          const conversion = row.conversion;
          // A row with a `basis` (Purchase) is counted against every member,
          // not the stage above it, so say which population the % is of.
          const of = row.basis
            ? `of ${row.basisLabel || "members here today"}`
            : "of the previous stage";
          return `${val} users${conversion !== undefined ? ` (${conversion}% ${of})` : ""}`;
        },
      },
    },
  };

  return (
    <div className="mb-4">
      <Chart  key={data.length}  options={options} series={series} type="bar" height={420} />
    </div>
  );
};

export default FunnelChart;
